import axios from 'axios';
export const commonHeaders = {
    'content-type': 'application/json',
};
const defaultConf = {
    headers: commonHeaders,
};
export const generateConf = (conf, onUnauthorized) => {
    const HTTP = axios.create({
        ...defaultConf,
        ...conf,
    });
    HTTP.interceptors.response.use((r) => r, (err) => {
        console.error('API ERROR: ', err.response || err);
        if (err.response.status === 401 && onUnauthorized) {
            onUnauthorized();
        }
        return Promise.reject(err.response || err);
    });
    return HTTP;
};
//# sourceMappingURL=axios.js.map